import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { createUseStyles } from 'react-jss';
import { ThemeType } from '../../styles/theme';
import Zzeung from '../../lib/myid-sdk-client-web/lib/index';
import notice from '../../assets/06IconIi@2x.png';
import zzeungImg from '../../assets/adBanner/adbanner-2@2x.png';

const ZzeungNotice: React.FC = () => {
	const classes = useStyles();

	const closeWebview = () => {
		Zzeung.CloseWebView();
	};

	return (
		<>
			<Helmet>
				<title>NH농협은행 실명인증 발급 중단 안내</title>
			</Helmet>
			<div className={classes.wrap}>
				<div className={classes.desc}>
					<div className={classes.blank}></div>
					<div>
						<div className={classes.title}>
							<h1>
								NH농협은행 실명인증 <br /> 발급 중단
							</h1>
						</div>
						<div className={classes.img_area}>
							<img src={zzeungImg} alt="NH농협은행 실명인증 발급 중단" />
						</div>
						<ul className={classes.list}>
							<li>NH농협은행 실명인증의 발급과 재발급이 중단되었습니다.</li>
							<li>
								그동안 서비스를 사랑해주신 분들께 감사드리며 종료하는 순간까지
								이용에 불편함이 없도록 최선을 다하겠습니다.
							</li>
						</ul>
					</div>
					<div className={classes.caption}>
						<div className={classes.guide}>
							종료일시 이후는 해당 서비스를 이용할 수 없으니 미리 확인하시어
							착오가 없으시길 바랍니다.
						</div>
					</div>
				</div>
				<div className={classes.float}>
					<button className={classes.button}>확인</button>
				</div>
			</div>
			<div className={classes.float}>
				<button onClick={closeWebview} className={classes.button}>
					확인
				</button>
			</div>
		</>
	);
};

const useStyles = createUseStyles((theme: ThemeType) => ({
	wrap: {
		width: '100%',
		position: 'relative',
	},
	desc: {
		width: '100%',
		height: '100vh',
		overflow: 'scroll',
		padding: '0 20px 94px 20px',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'space-between',
		fontFamily: theme.font,
	},
	blank: {
		minHeight: 60,
	},
	title: {
		wordBreak: 'keep-all',
		'& > h1': {
			lineHeight: '3.6rem',
			textAlign: 'center',
			letterSpacing: -0.2,
			fontSize: theme.t1,
			fontWeight: theme.medium,
		},
	},
	img_area: {
		margin: '26px 0',
		textAlign: 'center',
		'& > img': {
			display: 'inline-block',
		},
	},
	list: {
		padding: `0px 0px 10px 13px`,
		justifyContent: 'center',
		fontSize: '1.6rem',
		color: theme.mono50,
		lineHeight: '2.6rem',
		listStyleType: 'none',
		'& > li': {
			position: 'relative',
			margin: '0 0 18px 14px',
		},
		fontWeight: theme.demiLight,
		'& > li::before': {
			content: '"·"',
			width: 9,
			position: 'absolute',
			left: '-1.4rem',
		},
	},
	caption: {
		width: '100%',
	},
	guide: {
		fontSize: '1.4rem',
		lineHeight: '2.2rem',
		color: theme.mono50,
		paddingLeft: 22,
		background: `url(${notice}) left 0px top 5px no-repeat`,
		backgroundSize: 16,
	},
	float: {
		width: '100%',
		position: 'fixed',
		bottom: 0,
		padding: 20,
		backgroundColor: '#FFF',
	},
	button: {
		width: '100%',
		height: 54,
		fontSize: '1.8rem',
		background: theme.primarySol,
		color: theme.mono100,
		padding: '13px 20px',
		fontWeight: theme.regular,
		borderRadius: 6,
	},
}));

export default ZzeungNotice;
